import Typography, { type TypographyProps } from "@mui/material/Typography";

/** The single, top-level title of a page. Renders as an `<h1>`. */
export function PageTitle(props: TypographyProps) {
  return <Typography variant="h4" component="h1" {...props} />;
}
